export const COPILOT_STATUS = {
    IDLE: 'idle',
    LOADING: 'loading',
    READY: 'ready',
    DISABLED: 'disabled',
    ERROR: 'error',
};
